import React from "react";
import PropTypes from "prop-types";
import appLogo from "assets/logo/logo-only.png";
import "../../index.scss";

const Invoice = ({
  payment,
  order,
  product,
  formatTotal,
  formatSubTotal,
  formatIssuedDate,
  formatGST,
  title,
  startDate,
  endDate,
  farms,
}) => {
  return (
    <>
      <div className="invoice-wrapper">
        <img className="app-logo" src={appLogo} alt="alt" />
        <h1 className="title">{title}</h1>
        <div className="divider" />
        <div className="invoice-layout">
          <p className="pill">Invoice Details</p>
          <div className="invoice-details">
            <div className="detail-item -block">
              <p className="text">
                {formatTotal.toLocaleString("en-US", {
                  style: "currency",
                  currency: "USD",
                })}
              </p>
              <label className="label">Amount Due</label>
            </div>
            <div className="detail-item">
              <p className="text">{payment?.invoice_number}</p>
              <label className="label">Invoice Number</label>
            </div>
            <div className="detail-item">
              <p className="text">{formatIssuedDate}</p>
              <label className="label">Date Issued</label>
            </div>
            <div className="detail-item">
              <p className="text">{order?.id}</p>
              <label className="label">Reference Number</label>
            </div>
            <div className="detail-item">
              <p className="text">56 619 577 150</p>
              <label className="label">ABN</label>
            </div>
          </div>
        </div>
        <div className="divider" />
        <div className="invoice-layout">
          <p className="pill">Billed from</p>
          <div className="invoice-details">
            <div className="detail-item -block">
              <p className="text">Data Farming Pty Ltd.</p>
              <label className="label">
                P.O.Box 253, Highfields, Toowoomba
              </label>
              <label className="label">Queensland 4352</label>
              <label className="label">Australia</label>
              <label className="label">accounts@datafarming.com</label>
            </div>
          </div>
        </div>
        <div className="divider" />
        <div className="invoice-layout">
          <p className="pill">Billed to</p>
          <div className="invoice-details">
            <div className="detail-item -block">
              <p className="text">
                {order?.first_name} {order?.last_name}
              </p>
              <label className="label">{order?.street}</label>
              <label className="label">
                {order?.state} {order?.suburb} {order?.post_code}
              </label>
              <label className="label">{order?.country}</label>
            </div>
          </div>
        </div>
      </div>
      <div className="invoice-wrapper -bordered">
        <h1 className="title">Payment Terms</h1>
        <p className="terms">To be paid within 14 days</p>
        <div className="divider" />
        <div className="invoice-layout">
          <p className="pill">Deposit Details</p>
          <div className="invoice-details">
            <div className="detail-item -block">
              <p className="text">
                {formatTotal.toLocaleString("en-US", {
                  style: "currency",
                  currency: "USD",
                })}
              </p>
              <label className="label">Amount Due</label>
            </div>
            <div className="detail-item">
              <p className="text">034-008</p>
              <label className="label">BSB</label>
            </div>
            <div className="detail-item">
              <p className="text">376630</p>
              <label className="label">Account Number</label>
            </div>
            <div className="detail-item">
              <p className="text">DataFarming Pty Ltd.</p>
              <label className="label">Name of Account</label>
            </div>
            <div className="detail-item">
              <p className="text">WPACAU2S</p>
              <label className="label">Swift Code</label>
            </div>
          </div>
        </div>
      </div>
      <div className="invoice-wrapper -filled">
        <h1 className="title">Order Summary</h1>
        <div className="item-table -header">
          <p className="header -left">Item</p>
          <p className="header">Unit Price Per Area</p>
          <p className="header">Total Area</p>
          <p className="header">Total Cost</p>
        </div>
        <div className="divider" />
        <div className="item-table">
          <div className="item -left">
            <p className="item-text -bold">{product[0]?.title}</p>
            <div
              className="detail-item"
              style={{ marginBottom: "8px", marginTop: "8px" }}
            >
              <label className="label">FARMS</label>
            </div>
            <div className="detail-item" style={{ marginBottom: "8px" }}>
              {farms
                ? farms.map((farm) => (
                    <div className="item-text">
                      {farm?.newFarms.properties?.farm_name}
                    </div>
                  ))
                : null}
            </div>
            <div className="detail-item">
              <label className="label">DETAILS</label>
              <div className="text-group">
                <p className="item-text">
                  {order?.specification?.config?.number_of_captures} Captures
                </p>
                <div className="circle" />
                <p className="item-text">
                  {order?.specification?.field_ids?.length} Fields
                </p>
              </div>
              <p className="item-text">
                Capture Range from {startDate} to {endDate}
              </p>
            </div>

            <p className="item-text -small">
              {order?.minimum_hectare_requirements_pricing
                ? "**Minimum pricing affects this order"
                : ""}
            </p>
          </div>
          <p className="item">
            {formatTotal.toLocaleString("en-US", {
              style: "currency",
              currency: "USD",
            })}
          </p>
          <p className="item">{order?.total_product_unit.toFixed(2)}</p>
          <p className="item">
            {formatTotal.toLocaleString("en-US", {
              style: "currency",
              currency: "USD",
            })}
          </p>
        </div>
        <div className="payment-details">
          <div className="payment-cost">
            <p className="text">Subtotal</p>
            <p className="cost">
              {formatSubTotal.toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
              })}
            </p>
          </div>
          <div className="payment-cost">
            <p className="text">GST</p>
            <p className="cost">
              {formatGST.toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
              })}
            </p>
          </div>
          <div className="payment-cost">
            <p className="text">Total Cost</p>
            <p className="cost">
              {formatTotal.toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
              })}
            </p>
          </div>
          <div className="payment-cost">
            <p className="text">Total Net Payments</p>
            <p className="cost">$0.00</p>
          </div>
          <div className="payment-cost">
            <p className="text">Amount Due</p>
            <p className="cost">
              {formatTotal.toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
              })}
            </p>
          </div>
        </div>
      </div>
      {/*       
      <div className="item-divider">
        {product && (
          <div>
            <label className="label">Item</label>
            <div>
            <p className="text">{product[0]?.title}</p>
              <p className="text">
                Capture Range: {startDate} - {endDate}
              </p>
              <p className="text">Total Captures: </p>
              <p className="text">
                No. of Fields: {order?.specification?.field_ids?.length}
              </p>
              <p className="text">
                {order?.minimum_hectare_requirements_pricing
                  ? "**Minimum pricing affects this order"
                  : ""}
              </p>
            </div>
          </div>
        )}
        <div>
          <label className="label">Cost</label>
          <p className="text">
            {formatTotal.toLocaleString("en-US", {
              style: "currency",
              currency: "USD",
            })}
          </p>
        </div>
        <div>
          <label className="label">Quantity</label>
          <p className="text">1</p>
        </div>
        <div>
          <label className="label">Total Price</label>
          <p className="text">
            {formatTotal.toLocaleString("en-US", {
              style: "currency",
              currency: "USD",
            })}
          </p>
        </div>
      </div>
      <div className="amount-wrapper ">
        <label className="text">Subtotal</label>
        <p className="text">
          {formatSubTotal.toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
          })}
        </p>
      </div>
      <div className="amount-wrapper ">
        <label className="text">GST</label>
        <p className="text">
          {formatGST.toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
          })}
        </p>
      </div>
      <div className="amount-wrapper">
        <label className="text">Total Cost</label>
        <p className="text">
          {formatTotal.toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
          })}
        </p>
      </div>
      <div className="amount-wrapper">
        <label className="text">Total Net Payments</label>
        <p className="text">$0.00</p>
      </div>
      <div className="amount-wrapper">
        <div>
          <label className="label">Amount Due</label>
        </div>
        <div>
          {formatTotal.toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
          })}
        </div>
      </div>
      <div className="group-wrapper">
        <h1>Payment Advice</h1> <div />
        <div>
          <label className="label">Direct Deposit Details:</label>
          <div className="text">BSB: 034-008</div>
          <div className="text">Account Number: 376630</div>
          <div className="text">Name of Account: DataFarming Pty Ltd.</div>
          <div className="text">Swift Code: WPACAU2S</div>
        </div>
        <div>
          <label className="label">Payment Terms:</label>
          <p className="text">To be paid within 14 days</p>
        </div>
      </div> */}
    </>
  );
};

Invoice.propTypes = {
  payment: PropTypes.shape({
    updated_on: PropTypes.string.isRequired,
    invoice_number: PropTypes.string.isRequired,
  }).isRequired,
  order: PropTypes.shape({
    first_name: PropTypes.string.isRequired,
    last_name: PropTypes.string.isRequired,
    street: PropTypes.string.isRequired,
    suburb: PropTypes.string.isRequired,
    country: PropTypes.string.isRequired,
    post_code: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    specification: PropTypes.shape({
      field_ids: PropTypes.string.isRequired,
      config: PropTypes.shape({
        number_of_captures: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
    minimum_hectare_requirements_pricing: PropTypes.string.isRequired,
    total_product_unit: PropTypes.string.isRequired,
  }).isRequired,
  formatGST: PropTypes.string.isRequired,
  formatIssuedDate: PropTypes.string.isRequired,
  formatSubTotal: PropTypes.string.isRequired,
  formatTotal: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  product: PropTypes.shape({
    title: PropTypes.string.isRequired,
  }).isRequired,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  farms: PropTypes.shape({
    map: PropTypes.func.isRequired,
  }).isRequired,
};

export default Invoice;
